module.exports = __webpack_public_path__ + "static/media/photo-1520483691742-bada60a1edd6.11497259.jfif";